// Internal
import { SUCCESS, FAILURE } from 'shared/constants/actions';
import appTypes from 'shared/utils/actions';

const marketingUnsubscribe = appTypes.defineAction('marketingUnsubscribe');

export const FETCH_UNSUBSCRIBE = marketingUnsubscribe.defineAction('FETCH_UNSUBSCRIBE', [SUCCESS, FAILURE]);
export const SET_UNSUBSCRIBE_USER = marketingUnsubscribe.defineAction('SET_UNSUBSCRIBE_USER');
